import api from '../client'

export async function fetchUserOptions(search = '', page = 1, pageSize = 20, extraParams = {}) {
  const params = { search, page, page_size: pageSize, ...extraParams }
  const { data } = await api.get('/users/', { params })
  const rawItems = Array.isArray(data) ? data : Array.isArray(data?.items) ? data.items : []
  const items = rawItems.map((item) => ({
    value: String(item.id),
    label: item.name || item.email || String(item.id),
  }))
  const hasMore = rawItems.length === pageSize
  return { items, hasMore }
}
